import { NavLink, useNavigate } from "react-router-dom";
import { Button } from "../../../components/ui/button";
import SUPER_TABS from "../config";
import UserInfo from "../../../components/UserInfo";
import LogOut from "../../../components/LogOut";
import { useTranslation } from "../../../i18n";

export default function SuperSidebar({ onNavigate }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex flex-col space-y-3 xl:space-y-4 h-full min-w-fit">
      <UserInfo />
      <Button
        variant="secondary"
        onClick={() => navigate("/dashboard/admin/recent-customer")}
      >
        {t("admin.employeePanel")}
      </Button>
      <div className="bg-c-gray-600 flex flex-col justify-center space-y-4 p-2 rounded-lg">
        {SUPER_TABS.map(({ path, titleKey, icon: Icon }) => (
          <NavLink
            key={path}
            to={path}
            onClick={onNavigate}
            className={({ isActive }) =>
              `flex flex-row justify-start items-center space-x-2 whitespace-nowrap focus:outline-none font-medium rounded-lg px-3 py-1 text-center ${
                isActive
                  ? "bg-accent text-primary-foreground"
                  : "bg-c-gray-600 text-white hover:bg-accent-hover"
              }`
            }
          >
            {Icon && <Icon className="h-6 w-6" />}
            <h1>{t(titleKey)}</h1>
          </NavLink>
        ))}
      </div>
      <LogOut />
    </div>
  );
}
